import { render } from "./UserContacts.vue?vue&type=template&id=f1b7687a"
import script from "./UserContacts.vue?vue&type=script&lang=js"
export * from "./UserContacts.vue?vue&type=script&lang=js"

import "./UserContacts.vue?vue&type=style&index=0&id=f1b7687a&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__